'use client'

import classNames from 'classnames'
import { StyledSwoosh } from './swoosh.styles'

export const Swoosh = ({ color = 'secondary', className, children, ...props }) => {
  return <StyledSwoosh className={classNames("swoosh", className)} color={color} {...props}>{children}</StyledSwoosh>
}
